export const EMAIL_REGEX = '^[\\w-\\.]+@([\\w-]+\\.)+[\\w-]{2,4}$';
export const TEL_REGEX = '^([+]\\d{2})?\\d{10}$';
export const BASE_URL = 'https://react-burger-d81b5.firebaseio.com/';
export const WEB_API_KEY = 'AIzaSyDJtwWIEYsTGqV0SLBdtWFiQZLcJY1qgG4';
export const AUTH_TOKEN = 'auth_token';